/* eslint-disable sort-keys */
export const translation = {
  CertMasterAuthenticateModal: {
    Instructions:
      'Log in to your <a>CertMaster</a> account to link it to this CompTIA account. Your purchased courses will then appear.',
    UsernameLabel: 'Username',
    PasswordLabel: 'Password',
    LoginBtn: 'Log In and Link Accounts',
    ForgotLink: 'Forgot your username or password?',
    SupportLink: 'Contact CompTIA support',
    AlreadyLinked:
      'The platform account you entered is already linked to a CompTIA account. Please contact support for help connecting.',
    LoginFailed:
      'Username and/or password is not recognized. Please contact support for help connecting accounts.',
  },
  Button: {
    Edit: 'Edit',
    Cancel: 'Cancel',
  },

  ComingSoon: {
    ReleaseDate: 'Coming Soon!',
    RedeemAccessKeys:
      'Soon you will be able to redeem access keys for your new CompTIA training products from this page. Check back for updates!',
    AccessYourTraining:
      'Soon you will be able to access all your CompTIA training from this page. Check back for updates!',
    BrowseTraining: 'Browse Training',
  },

  Loading: {
    Default: 'Please Wait',
    AddressVerification: 'Verifying Address',
    RedeemingAccessKey: 'Redeeming Access Key',
    UpdatingProfile: 'Updating Profile',
    UpdatingEmail: 'Updating Email',
    UpdatingPassword: 'Updating Password',
    SendingVerificationCode: 'Sending Verification Code',
    ResendingVerificationCode: 'Sending New Verification Code',
  },

  Toast: {
    Action: {
      Dismiss: 'Got It',
    },
    Error: {
      Default: 'An unexpected error ocurred. Please try again later.',
    },
    Success: {
      EditProfile: 'Your profile was successfully updated.',
      EditEmail:
        'Your email has been successfully changed. You are being redirected to the login page to sign in with your new email.',
      EditPassword: 'Your password was successfully updated.',
      VerificationCodeSent:
        'A verification code has been sent to your new email. Please enter it on the next step to change your email.',
    },
  },

  Validation: {
    AlternateEmail: 'Cannot be your alternate email',
    CurrentEmail: 'Cannot be your current email',
    CurrentPassword: 'Must be different than current password',
    InvalidAddress: 'Invalid address',
    InvalidCity: 'Invalid city',
    InvalidCountry: 'Invalid country',
    InvalidCountryCode: 'Invalid country code',
    InvalidName: 'Invalid name',
    InvalidPassword:
      '10-24 characters, containing 3 out of 4 of the following: Lowercase characters, uppercase characters, digits (0-9), and one or more of the following symbols: @ # $ % ^ & * - _ + = [] {} | \\ : \' , ? / ` ~ " () ; ! .',
    InvalidPhoneNumber: 'Invalid phone number',
    InvalidPostalCode: 'Invalid postal code',
    InvalidState: 'Invalid state',
    MaximumLength: 'Exceeds maximum length',
    PasswordsMatch: 'Passwords do not match',
    PrimaryEmail: 'Must not match primary email',
    PrimaryPhoneNumber: 'Must not match primary phone number',
    Required: 'Required',
    ValidEmail: 'Must be a valid email',
    ValidBirthDay: 'Invalid birth day',
    validMobilePhoneNumber:
      'Please enter a mobile number to receive SMS messages',
  },

  PearsonError: {
    Button: 'Go Back to the Homepage',
    Default:
      'An unexpected error has ocurred in the Pearson VUE system. Please contact the call center for assistance.',
    CandidateNotFound:
      'The Pearson VUE candidate was not found. Please contact the call center for assistance.',
    ClientNotSupported:
      'The Pearson VUE client is not supported. Please contact the call center for assistance.',
    InvalidPayload:
      'The Pearson VUE payload authentication hash did not match. Please contact the call center for assistance.',
    MissingRequiredParameters:
      'A required Pearson VUE payload parameter was not provided by the client. Please contact the call center for assistance.',
    RegistrationNotFound:
      'The Pearson VUE exam registration ID was not found. Please contact the call center for assistance.',
    SessionTimeout:
      'The Pearson VUE request has timed out. Please contact the call center for assistance.',
    Temporary:
      'The Pearson VUE website is experiencing a temporary planned outage. Please contact the call center for assistance.',
    VueWideBlock:
      'Your access to the Pearson VUE website is restricted at this time. This could be due to a variety of circumstances, including past payment issues, etc.<br><br> Please contact Pearson VUE\'s customer service team directly at 877-551-7587 to inquire about and resolve this restriction. You may also find other Pearson VUE contact methods (including chat and email <a href="https://home.pearsonvue.com/comptia/contact/proctored" style="outline: none;" target="_blank">here</a>.)',
  },

  FullfillmentBanner: {
    'Title-1':
      'You have a certification kit ready to be mailed. Click here to verify your address.',
    Button: 'Verify Address',
  },

  AddressVerificationModal: {
    Title:
      'Once you have verified your address, your fulfillment will be sent.',
    SuccessMessage:
      'Your address has been verified and your certification kit will be mailed.',
    Button: 'Verify Address',
  },

  ProfileMenu: {
    CompTIA: 'CompTIA ID',
    'Nav-1': 'My profile',
    'Nav-2': 'My login credentials',
    'Nav-3': 'My training courseware',
    Button: 'Sign Out',
    'Link-1': 'Legal',
  },

  Navigation: {
    'Link-Cert': 'Certification',
    'Link-Home': 'Home',
    'Link-1': 'Schedule Exam',
    'Link-2': 'Manage Exams',
    'Link-3': 'Manage Certifications',
    'Link-4': 'Access Training',
    'Link-5': 'Redeem Access Keys',
    'Link-Return': 'Return to Home',
    'Link-GoBack': 'Go Back',
    'Link-MyExams': 'My Exams',
    'Link-Certifications': 'Certifications',
    'Link-ContinuingEducation': 'Continuing Education',
  },

  HomeView: {
    WelcomeHeading: 'Welcome to CompTIA Central',
    ExamsAndCertification: 'Exams and Certification',
  },

  ExamRegistration: {
    Accommodations: 'Request Test Accommodations',
    AccommodationsUrl:
      'https://www.pearsonvue.com/us/en/test-takers/accommodations/pearson_approve.comptia.html',
    Title: 'Schedule your exam',
    Content: 'Take your exam in person or online.',
    'List-1': 'Select a test center or online',
    'List-2': 'Choose your date and time',
    'List-3': 'Review exam policies',
    Button: 'Schedule Now',
    'Button-2': 'Learn More',
    Blocked:
      'Your account has been temporarily suspended from registering for CompTIA certification exams. For questions about this suspension, please contact <a href="mailto:security@comptia.org">security@comptia.org</a> and provide your CompTIA ID number. Thank you.',
  },

  PearsonVueDashboard: {
    AccommodationsUrl:
      'https://www.pearsonvue.com/us/en/test-takers/accommodations/pearson_approve.comptia.html',
    Title: 'Manage Exams',
    Content:
      'Schedule or change your exam, Launch your online exam and view score reports',
    Button: 'Schedule and Manage Exams',
    'Button-2': 'View Testing Options',
    'Button-3': 'Request Test Accommodations',
  },

  CertificationAccount: {
    Title: 'Access Certifications',
    Content:
      'View certification status, pay CE fees, Submit CEUs and download PDFs of your certificates',
    Button: 'Certifications',
    ButtonAcct: 'View Certification Account',
    ButtonCe: 'Continuing Education',
  },

  AccessYourTraining: {
    Title: 'Training',
    Redeem: 'Redeem Access Key',
    Content: 'Open your study guides, labs and eLearning courses.',
    Content2:
      'Don\'t see your course(s) listed here? In some cases, your course(s) may be accessed outside of this login portal. <a href="https://help.comptia.org/hc/en-us/articles/11204948577044-Accessing-Training-Products-Through-Your-CompTIA-SSO-Account" rel="noopener noreferrer" target="_blank">Learn More</a>.',
    Content3:
      'To access the most recent CertMaster Learn, Perform, and Labs courses, along with legacy TestOut "Pro" courses. <linktag>Sign in here</linktag>.',
    Content4:
      'Not seeing a course? Find it by linking this CompTIA account to an <linktag>unlinked</linktag> account you own. <linktag2>Link accounts here.</linktag2>',
    Button: 'Get Started',
    'Link-1': 'CertMaster Labs',
    'Link-2': 'CertMaster Practice',
    'Link-3': 'Student & Instructor Guides',
    'Link-4': 'CertMaster Learn',
    'Link-5': 'Self-Paced Study Guides',
    'Link-6': 'CertMaster CE',
    'Link-7': 'CompTIA Labs',
    'Link-8': 'CompTIA Direct - Live Online Training',
    'Link-9': 'On Demand Training',
    MigrateTitle: 'Course Migration Notice',
    MigrateContent1: 'This course has migrated to ',
    MigrateContent2: 'You can continue to use ',
    MigrateContent3:
      'until it retires, but we recommend switching to the latest version of',
    Study: 'Study',
  },

  RedeemInformation: {
    Content:
      "For store purchases, access keys are sent by email following order completion, and may also be retrieved from your store account's Order History. For instructor-led training, access keys are typically distributed by an instructor or institution admin.",
    Title: 'Where do I find the access key?',
  },

  RedeemModule: {
    Label: 'Enter Key',
    Button: 'Redeem Now',
    Content:
      'Enter your training course access key. If you have multiple access keys, enter and redeem them one at a time.',
    Title: 'Redeem Access Key',
    NoProducts: 'This access key has reached its maximum redemption limit.',
    Details: {
      Content:
        'Please enter your Company and Country to complete the access key redemption process.',
      Cta: 'Continue',
    },
    Demograpghics: {
      Content:
        'Please fill out the following information to complete the access key redemption process.',
      Cta: 'Continue',
    },
    Products: {
      Content:
        'There are multiple courses associated with this access key, which course would you like to redeem?',
      Label: 'Select Course',
      Cta: 'Continue',
    },
    Success: {
      Content:
        'You have successfully redeemed your access key. You may now access your new training course or view all your courses.',
      Cta: 'Access my new training',
      ViewAll: 'View All My Courses',
      LOT: 'LOT',
    },
    CertMasterRedemtionStatus: {
      Success: 'Access key redeemed successfully.',
      InvalidKey: 'The access key is invalid.',
      CanExtendAccess: 'You can extend your access with this key.',
      UserProfileNotFound: 'User profile not found.',
      HasProductAlready: 'You already have this course.',
      ReservationNotFound: 'Reservation not found.',
      ReservationAlreadyUsed: 'Reservation has already been used.',
      ReservationExpired: 'Reservation has expired.',
      ReservationOverUsed: 'Reservation has been overused.',
      BadExpiration: 'Bad expiration date for the reservation.',
      DuplicateReservationForUser: 'Duplicate reservation for user.',
      InvalidReservation: 'Invalid reservation.',
      Ls5ReservationNotSupportedSchools:
        'LS5 reservations are not supported for schools.',
      Ls5ReservationNotSupportedTrials:
        'LS5 reservations are not supported for trials.',
      UnknownError: 'An unknown error occurred.',
      TempAccessAlreadyUsed: 'Temporary access has already been used.',
      ReservationNotActiveYet: 'Reservation is not active yet.',
      SingleProductLinkReservationsMustActivateSubLicenses:
        'Single course link reservations must activate sub-licenses.',
    },
  },

  NeedHelp: {
    Title: 'Need help?',
    Content: 'Review FAQs and contact our customer service team.',
    'List-1': 'Changing the legal first name and last name on your account',
    'List-2': 'Merging multiple accounts under a single login',
    'List-3': 'Releasing your pending certification kit for fulfillment',
    Button: 'Get Help',
  },

  ExploreLaunchpad: {
    Title: 'CompTIA Launchpad is the single source for all your exam materials',
    Content:
      'Your single login for your CompTIA training and certification journey.',
    Button: 'Explore Launchpad',
  },

  OnboardingSecure: {
    Button: 'Learn More',
    Title: 'Secure',
    Content:
      'CompTIA Launchpad is the easy and secure way to access all your products, services, tests, certifications and more.',
    'Title-2': 'Secure',
    'Content-2': 'Waiting on back of card final details.',
  },

  OnboardingConnected: {
    Button: 'Learn More',
    Title: 'Connected',
    Content:
      'CompTIA Launchpad allows you to see all your past, present, and upcoming tests. All conveniently linked to one account.',
    'Title-2': 'Connected',
    'Content-2': 'Waiting on back of card final details.',
  },

  OnboardingSimple: {
    Button: 'Learn More',
    Title: 'Simple',
    Content:
      'Easy log-in, industry-leading encryption, and you manage it all on the CompTIA Launchpad.',
    'Title-2': 'Simple',
    'Content-2': 'Waiting on back of card final details.',
  },

  'HelpMenu-Labels': {
    'Link-1': 'Help Center',
    'Link-2': 'Merge Account Request',
    'Link-3': 'Name Change Request',
  },

  'HelpMenu-Links': {
    'Link-1': '/help',
    'Link-2':
      '/help?returnto=https://help.comptia.org/hc/en-us/articles/11184936256020-How-Can-I-Get-Multiple-Accounts-Merged',
    'Link-3':
      '/help?returnto=https://help.comptia.org/hc/en-us/articles/14075048104596-How-Do-I-Correct-or-Change-My-Name-on-My-Account',
  },

  'FooterColumn-2': {
    Title: 'Certifications',
    'Link-1': 'CompTIA Certifications',
    'Link-2': 'Training Products',
    'Link-3': 'Continuing Education',
  },

  'FooterColumn-3': {
    Title: 'Store',
    'Link-1': 'CompTIA Store',
  },

  Profile: {
    Address: {
      Address1: 'Address 1',
      Address2: 'Address 2',
      Address3: 'Address 3',
      AddressType: 'Address Type',
      City: 'City',
      Country: 'Country',
      PostalCode: 'Zip Code',
      State: 'State/Province',
    },
    AllowCompTIAMarketingContact:
      "Please keep me informed of special promotions, discounts, new product announcements and other offerings for CompTIA's products and services including association updates. I understand that my information on record in CompTIA's secured database will be used to evaluate the products and services that may best fit my needs. I reserve the right to change my opt-in selections at any time.",
    AllowCompTIAPartnerMarketingContact:
      "I would like to receive information from CompTIA's partners on any special promotions, discounts, new product announcements and other offerings that may benefit me. I reserve the right to change my opt-in selection at any time.",
    AllowConsentToGatherBirthInformation:
      'Do you consent to CompTIA collecting your month and year of birth?',
    AllowConsentToSendSmsTextMessages:
      'I consent to receive SMS text messages from CompTIA and affiliates for updates, promotions, and important information.',
    AllowConsentToGatherBirthInformation2:
      'I consent to CompTIA collecting my day, month and year of birth.',
    AllowCredentialReleaseToThirdParty:
      'I authorize CompTIA to release information pertaining to my credentials to third party organizations, government entities and academic institutions. I understand that in no event shall CompTIA, its officers, directors or employees be liable for any special, indirect, incidental or consequential damages or any damages resulting from the release of this information. I reserve the right to change my opt-in selections at any time.',
    AlternateEmail: 'Alternate Email',
    AlternatePhoneNumber: {
      CountryCode: 'Country code',
      Phone: 'Alternate Phone',
    },
    BirthMonth: 'Birth Month',
    BirthYear: 'Birth Year',
    BirthDay: 'Birth Day',
    Company: 'Company',
    Email: 'Email',
    GivenName: {
      FirstName: 'First Name',
      Heading: 'Legal Name',
      LastName: 'Last Name',
      MiddleName: 'Middle Name',
      Suffix: 'Suffix',
      Title: 'Title',
    },
    IsUsCitizenOlderThanEighteenYears:
      'Are you a US Citizen and at least 18 years of age?',
    IsOlderThanEighteenYears: 'Are you at least 18 years of age?',
    MobilePhoneNumber: {
      CountryCode: 'Country code',
      Phone: 'Mobile Phone',
    },
    PhoneNumber: {
      CountryCode: 'Country code',
      Phone: 'Phone',
    },
    Preferences: {
      Language: 'Correspondence Language',
    },
    PreferredName: {
      FirstName: 'First Name',
      FirstNameQualified: 'Preferred First Name',
      Heading: 'Preferred Name',
      LastName: 'Last Name',
      LastNameQualified: 'Preferred Last Name',
      MiddleName: 'Middle Name',
      Suffix: 'Suffix',
      Title: 'Title',
    },
    PrivacyPolicyAccepted:
      'I agree to CompTIA’s <a target="_blank" href="https://www.comptia.org/legal">Privacy Policy and Terms & Conditions</a>',
  },

  EditAccount: {
    Subheading: 'My login credentials',
    Required: 'Required*',
    Email: {
      Tab: 'My Email',
      Heading: 'Primary Email Address',
      EmailAddress: 'Email Address',
      ConfirmCurrentPassword: 'Confirm Current Password',
      Disclaimer:
        'You will be redirected to the login page to sign in with your new email.',
      VerificationInstructions:
        'A verification code will be sent to your new email.',
      Social: 'This is a social account. The email cannot be changed.',
      SendVerificationCode: 'Send Verification Code',
      ResendVerificationCode: 'Send New Verification Code',
      VerifyCode: 'Verify Code',
      VerificationCode: 'Verification Code',
      NewPassword: 'New Password',
      Submit: 'Submit',
    },
    Password: {
      Tab: 'My Password',
      Heading: 'Password',
      CurrentPassword: 'Current Password',
      NewPassword: 'New Password',
      ConfirmNewPassword: 'Confirm New Password',
      Social: 'This is a social account. The password cannot be changed.',
    },
    Cta: 'Save',
  },

  EditProfile: {
    Subheading: 'My profile',
    LegalName:
      'Please submit a <a href="https://help.comptia.org/hc/en-us/articles/14075048104596-How-Do-I-Correct-or-Change-My-Name-on-My-Account" rel="noopener noreferrer" target="_blank">name change request</a> to update or correct your legal name.',
    ParentGuardianInformation: 'Consent Information',
    ParentGuardianSubheading: 'Your account was given consent on {{date}}.',
    PersonalInformation: 'Personal Information',
    ContactInformation: 'Contact Information',
    AlternateContactInformation: 'Alternate Contact Information',
    AlternateContactSubheading:
      'We encourage you to provide an alternate email and alternate phone for future account recovery options.',
    Cta: 'Save',
  },

  PearsonDemographic: {
    Heading: 'Schedule and Manage Exams',
    Subheading:
      'Please confirm or complete the information below to begin the exam scheduling process.',
    YouMustEnter:
      'You must enter your legal name exactly as it appears on the identification you will present at the test center.',
    NameInEnglish: '',
    NoReimbursement:
      'IMPORTANT NOTE: Your legal name below must match the first name and last name as it appears on the ID you will present for exam check-in. If they do not match, you will not be able to take your exam and your exam fee will not be refunded.',
    Required: 'Required*',
    LegalName: 'Legal Name',
    PreferredName: 'Preferred Name',
    ContactInformation: 'Contact Information',
    Cta: 'Save Updates',
    MissingFields: 'You have missed required fields.',
  },

  TrainingProducts: {
    Subheading: 'My Training Courseware',
    HeadingTag: 'Entitlements',
    ProductType: 'Product Type',
    PersonalAccount: 'Personal Account',
    BusinessAccount: 'Business Account',
    ExpiresOn: 'Expires on',
    ExpiredOn: 'Expired on',
    NoProducts: 'You have not redeemed any training courses.',
    WaitingOnAgreement: 'Pending sync & agreement completion if applicable',
  },

  EmailVerification: {
    Title: 'Verify Your Email',
    Description:
      'To access your training courses, please verify your email address. Click the button below to send a verification code to your email.',
    SendCode: 'Send Verification Code',
    CodeSent:
      'A verification code has been sent to your email address. Enter the code below to verify.',
    CodeLabel: 'Verification Code',
    CodePlaceholder: 'Enter code',
    VerifyButton: 'Verify Email',
    ResendCode: 'Resend code',
    Success: 'Your email has been verified successfully.',
  },

  NotFound: {
    Heading: '404 Not Found',
    Subheading: "Can't find what you're looking for?",
    Button: 'Go to the CompTIA Account Home',
  },
  UpgradeAccountModal: {
    Title: 'Upgrade Account to Redeem Access Key',
    Intro:
      'To redeem your access key, we need to upgrade you to the latest CompTIA account.',
    NoAccount:
      'If you have an <linktag>unlinked, legacy CertMaster, or TestOut LabSim Platform account</linktag>, you can upgrade the account by linking it to this CompTIA account.',
    HasAccount:
      'We have detected an existing <linktag>unlinked, legacy CertMaster, or TestOut LabSim Platform account</linktag> with this email address <strong>{{email}}</strong>. You should login to that account and link it to this one. If you don’t know the password, you can recover it by selecting that option on the login screen for that platform and putting in your email address',
    Otherwise:
      'Otherwise, select "I Don\'t Have an Unlinked Account" to automatically upgrade.',
    Upgrading: 'What upgrading accounts means:',
    Item1:
      'Your access key will be redeemed and courses will be added to your CompTIA account.',
    Item2: "Your grades, scores, progress, and exams won't change",
    Item3:
      'If connected, this will replace your legacy CertMaster or TestOut LabSim Platform account login with your current CompTIA login.',
    ConnectAccount: 'Connect to Unlinked Account',
    DontHaveAccount: "I Don't Have an Unlinked Account",
    WhatLink: "What's an Unlinked or Legacy Account?",
  },
  UpgradeSuccessModal: {
    Title: 'Account Upgraded Successfully',
    Upgraded:
      'Your CompTIA account has been upgraded and your access key has been redeemed. Your course will now appear in your account.',
    Issue:
      'If you experience any issues, please <linktag>contact support</linktag>.',
    Continue: 'Continue to CompTIA Account Home',
  },
  LinkedSuccessfullyModal: {
    Title: 'Account Linked and Upgraded Successfully',
    Linked:
      'Your CompTIA account has been linked to your legacy CertMaster or TestOut LabSim Platform account.',
    Use: "You'll use your CompTIA login at <linktag>login.comptia.org</linktag> to access your courses from now on. Your former legacy CertMaster or TestOut LabSim Platform credentials will no longer work.",
    Issue:
      'If you experience any issues, please <linktag>contact support</linktag>.',
    Continue: 'Continue to CompTIA Account Home',
  },
  Links: {
    LegacyAccount:
      'https://help.comptia.org/hc/en-us/articles/35180001781396-What-is-an-Unlinked-CertMaster-or-TestOut-LabSim-Platform-account-and-Why-am-I-being-Asked-to-Link-it-to-a-CompTIA-account',
    Support: 'https://help.comptia.org/hc/en-us/requests/new',
  },
  NoActivationNeededModal: {
    Title: 'No Activation Needed',
    Courses: 'The access key that you entered is for the following course:',
    Courses_plural:
      'The access key that you entered is for the following courses:',
    NotUsed:
      'Since you already have access to this course, your access key will not be used.',
    NotUsed_plural:
      'Since you already have access to these courses, your access key will not be used.',
  },
  ErrorModal: {
    Title: 'Redemption Error',
    Content: 'There was an error redeeming your access key: ',
  },
  CertMasterEntry: {
    CoursewareHome: 'Courseware Home',
    ClassManagement: 'Class Management',
    InstitutionManagement: 'Institution Management',
    EmployeeTools: 'CompTIA Admin Portal',
  },
  MissingProductsModal: {
    Title: 'Link Accounts to Find Missing Courses',
    Content1:
      'Not seeing a course? It might be in an <linktag>unlinked or legacy account</linktag> you own, such as a LabSim Platform or TestOut LabSim account.',
    Content2:
      'To add your missing courses, please link your unlinked account to your current CompTIA account. Otherwise, select "Ignore" to close this message.',
    Content3: 'What linking accounts means:',
    Item1: 'Purchased courses will appear in this CompTIA account.',
    Item2: 'Your grades, scores, progress, and exams will not change.',
    Item3:
      "This will replace your unlinked account login with your current CompTIA login (which you'll continue to use).",
    Content4: "What's an Unlinked or Legacy Account?",
    Button1: 'Ignore',
    Button2: 'Link Account',
  },
  InfoText: {
    Unlinked:
      'Not seeing a course? Find it by linking this CompTIA account to an <linktag>unlinked</linktag> account you own. <linktag2>Link accounts here.</linktag2>',
    AccessKeys:
      "For store purchases, access keys are sent by email following order completion, and may also be retrieved from your store account's Order History. For instructor-led training, access keys are typically distributed by an instructor or institution admin.",
    NoCourses:
      'You currently have no courses. <linktag>Redeem an Access Key</linktag> to get started',
  },
};
